export const ACTION_TYPES = {
  CHECK_BIC_AND_IBAN: 'financial/CHECK_BIC_AND_IBAN',
  GET_HMAK: 'financial/GET_HMAK',
  SET_ERROR: 'financial/SET_ERROR',
  RESET_ERROR: 'financial/RESET_ERROR',
};
